// extracted by mini-css-extract-plugin
export default {"container":"InputDetectedFromWrongDevicePrompt_container__VyrGq","buttonSection":"InputDetectedFromWrongDevicePrompt_buttonSection__7tR+P"};